const constants = {
    'sistema': 'https://parcerias.ifes.edu.br/sistema/',
	'proex': 'https://proex.ifes.edu.br/parcerias'
}

export default constants